import React from 'react';
import {Grid} from "@material-ui/core";
import {Link} from "react-router-dom";

// images
import iconBg1 from '../../images/paystub_example.png';

import './style.scss';

const Paystubs = () => {
    return(
        <Grid className="OurPaystubs">
            <Grid className="container" container alignItems="center" spacing={4}>
                <Grid item xs={12} md={5}>
                    <Grid className="textContent">
                        <strong>Our Paystubs</strong>
                        <h4>Here’s What You Can Expect </h4>
                        <p>Providing everything you need for a professional Canadian pay stub for you and your employees. Our platform enables you to choose between annual and hourly income, enter multiple income types, automatically calculate deductions, add cash and non-cash taxable benefits, add year-to-date income, and preview it all before your purchase.</p>
                        <Link to="/about-us" className="cBtn">Sign Up</Link>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={7}>
                    <Grid className="OurPaystubsContent">
                        <div className="dstudioItem">
                            <img src={iconBg1} alt=""/>
                        </div>
                       
                     
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
};

export default Paystubs;